import React, {Fragment} from 'react';
import styled from 'styled-components';
import {withStyles} from '@material-ui/core/styles';
import Title1 from '../../../components/Typography/Title1';
import Headline from '../../../components/Typography/Headline';
import Body from '../../../components/Typography/Body';
import {PrimaryButton} from '../../../components/Buttons';
import Dialog from '@material-ui/core/Dialog';

const styles = theme => ({
  scrollPaper: {
    alignItems:
      typeof window !== 'undefined' && window.innerWidth < 786
        ? 'flex-end'
        : 'center',
  },
  paper: {
    margin: 0,
    maxWidth:
      typeof window !== 'undefined' && window.innerWidth < 786
        ? '300px'
        : '100%',
  },
  input: {
    fontFamily: theme.typography.fontFamily.main,
  },
});

const CreditWrapper = styled.div`
  width: 400px;
  padding: 20px;
  background: white;
  margin: auto;
  display: grid;
  grid-gap: 20px;

  @media (max-width: 786px) {
    padding: 24px 20px;
    width: 100%;
  }
`;

const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
`;

const Cancel = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: white;
  background-color: rgba(81, 78, 89, 0.63);
  right: 8px;
  top: 8px;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: ${props => props.theme.closeButtonHoverColor};
    transition: all 0.25s ease;
  }
`;

const CreditModal = ({
  setCreditModalIsVisible,
  creditModalIsVisible,
  classes,
  loyalty,
}) => {
  return (
    <Dialog
      id="CreditsModal-Dialog"
      aria-labelledby="credit"
      aria-describedby="credit"
      open={creditModalIsVisible}
      // onBackdropClick={() => setCreditModalIsVisible(false)}
      fullWidth={typeof window !== 'undefined' && window.innerWidth < 786}
      fullScreen={typeof window !== 'undefined' && window.innerWidth < 786}
      classes={{scrollPaper: classes.scrollPaper}}
      PaperProps={{classes: {root: classes.paper}}}
      scroll="body"
    >
      <CreditWrapper>
        <TitleWrapper>
          <Title1 id="CreditsModal-Title" style={{fontWeight: '600'}}>
            My Credits
          </Title1>
          <Cancel
            id="CreditsModal-Cancel"
            onClick={() => setCreditModalIsVisible(false)}
          >
            <i className="fal fa-times" />
          </Cancel>
        </TitleWrapper>
        {loyalty && (
          <Fragment>
            <Headline id="CreditsModal-Headline">
              You have a credit balance of ${loyalty.credits_available}
            </Headline>
            {loyalty.credits_available > 0 && (
              <Body id="CreditsModal-Message">
                This credit will be applied automatically on your next order.
                Any remaining balance will be applied on consecutive orders.
              </Body>
            )}
          </Fragment>
        )}
        <PrimaryButton
          id="CreditsModal-CloseButton"
          onClick={() => setCreditModalIsVisible(false)}
        >
          {' '}
          Close{' '}
        </PrimaryButton>
      </CreditWrapper>
    </Dialog>
  );
};

export default withStyles(styles)(CreditModal);
